import { Component, inject, input } from '@angular/core';
import { AbstractControl, FormGroup, FormsModule, NonNullableFormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UrlService } from '../../services/url.service';
import { finalize } from 'rxjs';
import { ToastService } from '../../../shared/services/toast.service';
import { LoadingButtonComponent } from "../../../shared/components/loading-button/loading-button.component";


@Component({
	selector: 'app-add-sitemap-modal',
	imports: [FormsModule, ReactiveFormsModule, LoadingButtonComponent],
	templateUrl: './add-sitemap-modal.component.html',
	styleUrl: './add-sitemap-modal.component.scss'
})
export class AddSitemapModalComponent {
	private readonly fb = inject(NonNullableFormBuilder);
	private readonly urlSrv = inject(UrlService);
	private readonly toastSrv = inject(ToastService);
	activeModal = inject(NgbActiveModal);

	readonly urlList = input<string[]>();
	readonly contextId = input.required<string>();

	showConfirmMessage: boolean = false;
	loading: boolean = false;

	sitemapForm: FormGroup = this.fb.group(
		{
			sitemaps: [undefined, [Validators.required, Validators.minLength(4)]]
		}
	);

	onSubmit(): void {
		const sitemaps: string[] = this.sitemapForm.controls['sitemaps'].getRawValue()?.split('\n');
		this.apiSaveUrls(sitemaps);
	}

	private apiSaveUrls(sitemaps: string[]) {
		this.loading = true;
		this.urlSrv.addSitemaps(this.contextId(), sitemaps)
			.pipe(finalize(() => this.loading = false))
			.subscribe({
				next: () => {
					this.toastSrv.show({ type: 'success', message: $localize`Sitemap aggiunte con successo` });
					this.activeModal.close();
				}
			});
	}
}
